package org.gymly.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.AddPhotoAlternate
import androidx.compose.material.icons.outlined.AttachFile
import androidx.compose.material.icons.outlined.CameraAlt
import androidx.compose.material.icons.outlined.DeleteOutline
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.PlainTooltip
import androidx.compose.material3.Text
import androidx.compose.material3.TooltipBox
import androidx.compose.material3.TooltipDefaults
import androidx.compose.material3.rememberTooltipState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TooltipIconActionButton(
    onClick: () -> Unit,
    tooltip: String,
    icon: ImageVector,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
    size: Dp = 36.dp,
    iconSize: Dp = 20.dp,
    tint: Color,
    borderColor: Color = tint.copy(alpha = 0.55f),
    backgroundColor: Color = Color.Transparent,
    contentDescription: String = tooltip,
) {
    TooltipBox(
        positionProvider = TooltipDefaults.rememberPlainTooltipPositionProvider(),
        tooltip = { PlainTooltip { Text(tooltip) } },
        state = rememberTooltipState(),
    ) {
        Box(
            modifier
                .size(size)
                .clip(RoundedCornerShape(8.dp))
                .border(1.5.dp, borderColor, RoundedCornerShape(8.dp))
                .background(backgroundColor),
            contentAlignment = Alignment.Center,
        ) {
            IconButton(
                onClick = onClick,
                enabled = enabled,
                modifier = Modifier.size(size),
            ) {
                Icon(
                    imageVector = icon,
                    contentDescription = contentDescription,
                    tint = if (enabled) tint else tint.copy(alpha = 0.38f),
                    modifier = Modifier.size(iconSize),
                )
            }
        }
    }
}

@Composable
fun PhotoActionBar(
    hasPhoto: Boolean,
    enabled: Boolean,
    onUpload: () -> Unit,
    onCapture: (() -> Unit)? = null,
    onRemove: (() -> Unit)? = null,
    compact: Boolean = false,
    accent: Color,
    error: Color,
    uploadTooltip: String = if (hasPhoto) "Cambiar archivo" else "Subir archivo",
    captureTooltip: String = "Capturar en terminal",
    removeTooltip: String = "Quitar foto",
    modifier: Modifier = Modifier,
) {
    val size = if (compact) 32.dp else 36.dp
    val iconSize = if (compact) 18.dp else 20.dp
    val spacing = if (compact) 6.dp else 8.dp

    Row(modifier, horizontalArrangement = Arrangement.spacedBy(spacing)) {
        TooltipIconActionButton(
            onClick = onUpload,
            tooltip = uploadTooltip,
            icon = Icons.Outlined.AddPhotoAlternate,
            enabled = enabled,
            size = size,
            iconSize = iconSize,
            tint = accent,
        )
        if (onCapture != null) {
            TooltipIconActionButton(
                onClick = onCapture,
                tooltip = captureTooltip,
                icon = Icons.Outlined.CameraAlt,
                enabled = enabled,
                size = size,
                iconSize = iconSize,
                tint = accent,
            )
        }
        if (hasPhoto && onRemove != null) {
            TooltipIconActionButton(
                onClick = onRemove,
                tooltip = removeTooltip,
                icon = Icons.Outlined.DeleteOutline,
                enabled = enabled,
                size = size,
                iconSize = iconSize,
                tint = error,
                borderColor = error.copy(alpha = 0.55f),
            )
        }
    }
}

@Composable
fun FileUploadIconButton(
    onClick: () -> Unit,
    tooltip: String,
    enabled: Boolean = true,
    tint: Color,
    icon: ImageVector = Icons.Outlined.AttachFile,
    modifier: Modifier = Modifier,
) {
    TooltipIconActionButton(
        onClick = onClick,
        tooltip = tooltip,
        icon = icon,
        enabled = enabled,
        tint = tint,
        modifier = modifier,
    )
}
